"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _elements = require("../../../styles/elements");

var _Table = require("../Table.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getWidth = function getWidth(width) {
  if (Number.isNaN(width)) {
    return width;
  }

  return "".concat(width, "px");
};

var TableBody = function TableBody(_ref) {
  var page = _ref.page,
      emptyHintVisible = _ref.emptyHintVisible,
      emptyHint = _ref.emptyHint,
      prepareRow = _ref.prepareRow;
  // width - padding of td
  var calcWidth = (0, _react.useCallback)(function (width, index) {
    var padding = _Table.tdPr + _Table.tdPl;

    if (index === 0) {
      // First td
      padding = _Table.tdPr + _Table.firstTdPl + _Table.firtdTdBorder;
    }

    return "calc(".concat(getWidth(width), " - ").concat(padding, "px)");
  }, []);

  if (page.length === 0 && emptyHintVisible) {
    return (0, _jsxRuntime.jsx)("tr", {
      css: [_elements.text.styles.textMediumDark, _elements.text.styles.italic, _elements.text.styles.fontNormal, process.env.NODE_ENV === "production" ? "" : ";label:TableBody;"],
      children: (0, _jsxRuntime.jsx)("td", {
        children: emptyHint
      })
    });
  }

  return page.map(function (row) {
    prepareRow(row);
    return (// row.getRowProps and will cell.getCellProps() return key prop
      (0, _jsxRuntime.jsx)("tr", _objectSpread(_objectSpread({}, row.getRowProps()), {}, {
        children: row.cells.map(function (cell, index) {
          return (0, _jsxRuntime.jsx)("td", _objectSpread(_objectSpread({}, cell.getCellProps()), {}, {
            children: cell.column.width === 'auto' || String(cell.column.width).indexOf('%') > -1 ? cell.render('Cell') : // Truncate cell when the width is explicit
            (0, _jsxRuntime.jsx)("div", {
              style: {
                width: calcWidth(cell.column.width, index)
              },
              className: "grui truncate",
              children: cell.render('Cell')
            })
          }));
        })
      }))
    );
  });
};

TableBody.propTypes = {
  page: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    cells: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}))
  })),
  emptyHintVisible: _propTypes.bool,
  emptyHint: _propTypes.string,
  prepareRow: _propTypes.func
};
TableBody.defaultProps = {
  page: [],
  emptyHintVisible: false,
  emptyHint: undefined,
  prepareRow: function prepareRow() {}
};
var _default = TableBody;
exports["default"] = _default;
//# sourceMappingURL=TableBody.js.map